/* =======================================
   HOMIES — Theme JS
   ======================================= */

(function () {
  'use strict';

  // ============ REVEAL ON SCROLL ============
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) entry.target.classList.add('in');
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));

  // ============ MOBILE MENU ============
  const mobileToggle = document.querySelector('[data-mobile-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const mobileClose = document.querySelector('[data-mobile-close]');
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', () => {
      mobileMenu.classList.add('open');
      document.body.classList.add('no-scroll');
    });
  }
  if (mobileClose && mobileMenu) {
    mobileClose.addEventListener('click', () => {
      mobileMenu.classList.remove('open');
      document.body.classList.remove('no-scroll');
    });
  }

  // ============ CART DRAWER ============
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartOverlay = document.querySelector('[data-cart-overlay]');
  const cartOpenButtons = document.querySelectorAll('[data-cart-open]');
  const cartCloseButton = document.querySelector('[data-cart-close]');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartOverlay && cartOverlay.classList.add('open');
    document.body.classList.add('no-scroll');
    refreshCart();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartOverlay && cartOverlay.classList.remove('open');
    document.body.classList.remove('no-scroll');
  }

  cartOpenButtons.forEach((b) => b.addEventListener('click', (e) => {
    e.preventDefault();
    openCart();
  }));
  cartCloseButton && cartCloseButton.addEventListener('click', closeCart);
  cartOverlay && cartOverlay.addEventListener('click', closeCart);

  // ============ CART AJAX ============
  async function fetchCart() {
    try {
      const res = await fetch('/cart.js');
      return await res.json();
    } catch (e) {
      console.error('Cart fetch failed', e);
      return null;
    }
  }

  async function addToCart(id, quantity) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: id, quantity: quantity || 1 }),
      });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.description || 'Failed to add to cart');
      }
      return await res.json();
    } catch (e) {
      console.error(e);
      alert(e.message || 'Could not add item. It may be out of stock.');
      return null;
    }
  }

  async function updateCartItem(line, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity }),
    });
    return await res.json();
  }

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return '$' + amount;
  }

  async function refreshCart() {
    const cart = await fetchCart();
    if (!cart) return;
    updateCartCount(cart.item_count);
    renderCart(cart);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = '(' + count + ')';
    });
  }

  function renderCart(cart) {
    const list = document.querySelector('[data-cart-items]');
    const footer = document.querySelector('[data-cart-footer]');
    const empty = document.querySelector('[data-cart-empty]');
    if (!list) return;

    if (cart.item_count === 0) {
      list.innerHTML = '';
      if (empty) empty.style.display = 'block';
      if (footer) footer.style.display = 'none';
      return;
    }

    if (empty) empty.style.display = 'none';
    if (footer) footer.style.display = 'block';

    list.innerHTML = cart.items.map((item, index) => {
      const img = item.image ? '<img src="' + item.image + '" alt="' + item.product_title + '">' : '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      return (
        '<div class="cart-item" data-line="' + (index + 1) + '">' +
          '<div class="cart-item-image">' + img + '</div>' +
          '<div class="cart-item-info">' +
            '<div class="cart-item-title">' + item.product_title + '</div>' +
            (variant ? '<div class="cart-item-variant">' + variant + '</div>' : '') +
            '<div class="cart-item-qty">' +
              '<button data-qty-down>−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button data-qty-up>+</button>' +
            '</div>' +
            '<button class="cart-item-remove" data-remove>Remove</button>' +
          '</div>' +
          '<div class="cart-item-price">' + formatMoney(item.final_line_price) + '</div>' +
        '</div>'
      );
    }).join('');

    const subtotal = document.querySelector('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

    // Bind quantity controls
    list.querySelectorAll('.cart-item').forEach((item) => {
      const line = parseInt(item.dataset.line, 10);
      const qty = cart.items[line - 1].quantity;
      item.querySelector('[data-qty-up]').addEventListener('click', async () => {
        await updateCartItem(line, qty + 1);
        refreshCart();
      });
      item.querySelector('[data-qty-down]').addEventListener('click', async () => {
        await updateCartItem(line, Math.max(0, qty - 1));
        refreshCart();
      });
      item.querySelector('[data-remove]').addEventListener('click', async () => {
        await updateCartItem(line, 0);
        refreshCart();
      });
    });
  }

  // Initial cart count load
  fetchCart().then((cart) => {
    if (cart) updateCartCount(cart.item_count);
  });

  // ============ PRODUCT FORM (add to cart) ============
  const productForms = document.querySelectorAll('[data-product-form]');
  productForms.forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const formData = new FormData(form);
      const id = formData.get('id');
      const quantity = formData.get('quantity') || 1;
      const btn = form.querySelector('[data-add-to-cart]');
      const originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      const result = await addToCart(id, parseInt(quantity, 10));
      btn.disabled = false;
      btn.textContent = originalText;
      if (result) {
        await refreshCart();
        openCart();
      }
    });
  });

  // ============ PRODUCT VARIANT SELECTOR ============
  const variantPickers = document.querySelectorAll('[data-variant-picker]');
  variantPickers.forEach((picker) => {
    const variants = JSON.parse(picker.dataset.variants || '[]');
    const form = picker.closest('form');
    const priceEl = document.querySelector('[data-product-price]');
    const comparePriceEl = document.querySelector('[data-product-compare-price]');
    const idInput = form && form.querySelector('input[name="id"]');
    const addBtn = form && form.querySelector('[data-add-to-cart]');

    function findVariant() {
      const selected = {};
      picker.querySelectorAll('.option-group').forEach((group) => {
        const name = group.dataset.optionName;
        const active = group.querySelector('.option-value.selected');
        if (active) selected[name] = active.dataset.value;
      });
      return variants.find((v) => {
        return Object.keys(selected).every((key) => v.options[key] === selected[key]);
      });
    }

    function updateSelected() {
      const variant = findVariant();
      if (!variant) {
        if (addBtn) { addBtn.textContent = 'Unavailable'; addBtn.disabled = true; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = 'inline';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (addBtn) {
        if (variant.available) {
          addBtn.textContent = 'Add to cart';
          addBtn.disabled = false;
        } else {
          addBtn.textContent = 'Sold out';
          addBtn.disabled = true;
        }
      }
      // Update selected value labels
      picker.querySelectorAll('.option-group').forEach((group) => {
        const name = group.dataset.optionName;
        const label = group.querySelector('.selected-value');
        if (label) label.textContent = variant.options[name] || '';
      });
    }

    picker.querySelectorAll('.option-value').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (btn.classList.contains('unavailable')) return;
        const group = btn.closest('.option-group');
        group.querySelectorAll('.option-value').forEach((b) => b.classList.remove('selected'));
        btn.classList.add('selected');
        updateSelected();
      });
    });

    updateSelected();
  });

  // ============ PRODUCT MEDIA THUMBS ============
  const mediaThumbs = document.querySelectorAll('[data-media-thumb]');
  mediaThumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const mainImg = document.querySelector('[data-media-main] img');
      if (mainImg) mainImg.src = thumb.dataset.fullSrc || thumb.querySelector('img').src;
      document.querySelectorAll('[data-media-thumb]').forEach((t) => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  // ============ QUANTITY CONTROL ON PDP ============
  const qtyControls = document.querySelectorAll('[data-qty-control]');
  qtyControls.forEach((control) => {
    const input = control.querySelector('input');
    control.querySelector('[data-qty-plus]').addEventListener('click', () => {
      input.value = parseInt(input.value, 10) + 1;
    });
    control.querySelector('[data-qty-minus]').addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value, 10) - 1);
    });
  });

  // ============ FILTER TOGGLE ============
  const filterToggle = document.querySelector('[data-filter-toggle]');
  const collectionLayout = document.querySelector('[data-collection-layout]');
  if (filterToggle && collectionLayout) {
    filterToggle.addEventListener('click', () => {
      collectionLayout.classList.toggle('with-filters');
      const isOpen = collectionLayout.classList.contains('with-filters');
      filterToggle.textContent = (isOpen ? 'Hide' : 'Show') + ' filters';
    });
  }

  // ============ NEWSLETTER ============
  const newsletterForms = document.querySelectorAll('[data-newsletter-form]');
  newsletterForms.forEach((form) => {
    // Let Shopify's native contact form handle it via the form action,
    // but show a nice confirmation on success via URL params
  });

})();
